import { init } from "@nosto/preact"
import { Serp, Category, HybridCategory, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { unbindOriginalSearch, addDependencies, createXBtn } from "./helpers"

import "./styles/index.css"

addDependencies();
unbindOriginalSearch(".header input[name='search']");

const excludedCategories = [ "419706536158" ] // collections/aunt-megan
const isHyridCategory = !document.getElementById('nosto-collection-target');

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: (isHyridCategory) ? HybridCategory : Category,
    inputCssSelector: '.header input[type="search"][name="q"]',
    // we dont want to render nosto on the fallback template
    contentCssSelector: "#MainContent:not(.fallback)",
    serpUrlMapping: {
        query: "search",
        "filter:": "filter",
        "page:": "page",
        "sort:": "sort"
    },
    serpPath: '/collections/shop',

    // search & collection fallback
    fallback: true,
    serpFallback: (searchQuery) => {
        location.replace(`/search?q=${searchQuery.query}`);
    },
    categoryFallback: (query) => {
        // prevent fallback template from being added multiple times because 
        //   categoryFallback function executes every time the page renders
        const replaceURL = window.location.href.indexOf("view=fallback") > -1;
        if (replaceURL){ return; }
        const url = window.location.href.indexOf("?") > -1 ? 
            window.location.href + "&view=fallback"
            : window.location.href + "?view=fallback";
        location.replace(url);
    },
    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: (location.pathname !== '/collections/shop'),
    serpQuery: {
        products: {
            fields: [
                "productId", "url", 
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "categories",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value",
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", 
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            // facets: ["*"]
        }
    },
    persistentSearchCache: true,
    preservePageScroll: true,
    compressUrlParameters: true,
    // Uncomment for Category Merchandising
    // categoryCssSelector: '#MainContent',
    isCategoryPage: () => (location.pathname.includes('/collections/') && location.pathname !== '/collections/shop'), 
    categoryCssSelector: (isHyridCategory) ? 'section[data-section="filters"]' : '#nosto-collection-target',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => {
    const inputEls = document.querySelectorAll('.header input[type="search"][name="q"]');
    inputEls.forEach(input => {
        input.setAttribute('autocomplete', 'off');
        const formEl = input.closest('form') || null;
        const historyEl = formEl?.querySelector('.nosto-autocomplete-wrapper > .nosto-autocomplete-wrapper > div');
        const mobileWrapper = input.closest('[data-hamburger-menu]');
        const xBtn = createXBtn();
        
        if(formEl && historyEl && xBtn) {
            formEl.appendChild(xBtn);

            const clearMobileSearch = (event) => {
                xBtn.classList.add('inactive');
                formEl.reset();
                event.target.closest('.search-container')?.click();
                input.focus(); /* show history.jsx */
            }

            const closeSearch = () => {
                if(mobileWrapper) {
                    mobileWrapper.querySelector('[data-search-close]')?.click();
                    xBtn.classList.add('inactive');
                } else {
                    document.querySelector('[data-section="header"]')?.click();
                }
                formEl.reset();
                if(document.body.classList.contains('overflow-hidden')) {
                    document.body.classList.remove('overflow-hidden');
                }
            }
            
            xBtn.addEventListener('click', (mobileWrapper) ? clearMobileSearch : closeSearch)
            if(mobileWrapper) {
                input.addEventListener('input', (event) => {
                    xBtn.classList.toggle('inactive', (event.target.value.length < 1))
                });
            } else {
                input.addEventListener('focus', (event) => {
                    xBtn.classList.remove('inactive');
                })
                input.addEventListener('blur', (event) => {
                    xBtn.classList.add('inactive');
                })
            }

            input.addEventListener('keyup', (event) => {
                if(event.keyCode === 13 || event.key === 'Enter' || event.key === 'Search') {
                    closeSearch();
                    scrollTo({ top: 0, behavior: 'smooth' })
                }
            });

            /* desktop: prevent scroll when search overlay active */
            const handleClick = (event) => {
                if(
                    !event.target.closest('.search-container[data-search-container]') || 
                    event.target.closest('[data-search-close]') ||
                    event.target.closest('[data-submit-search]') ||
                    event.target.closest('.ns-autocomplete-element') && 
                        event.target.closest('.ns-autocomplete-element').hasAttribute('data-nosto-query')
                ) {
                    document.body.classList.remove('overflow-hidden')
                    window.removeEventListener('click', handleClick)
                }
            }

            if(window.innerWidth >= 1024) {
                input.addEventListener('click', (event) => {
                    event.stopPropagation();
                    document.body.classList.add('overflow-hidden');
                    window.addEventListener('click', handleClick);
                })
            }
        };
    });
});